import Cookies from 'universal-cookie';
const cookies = new Cookies();

const initialServer = {
  contents: {
    'sign_up': { text: 'Sign Up' },
    'sign_up.facebook': { text: 'Facebook' },
    'sign_up.email': { text: 'E-mail' },
    'sign_up.twitter': { text: 'Twitter' },
    'login': { text: 'Login' },
    'login.facebook': { text: 'Facebook' },
    'login.email': { text: 'E-mail' },
    'login.twitter': { text: 'Twitter' },

    'my': { text: 'My Page' },
    'my.nodes': { text: 'My Nodes' },
    'my.liked': { text: 'My liked Nodes' },
    'my.followings': { text: 'My Following Users' },
    'user.ranking': { text: 'ユーザーランキング' },
  },
  fetch: { 'sign_up': true, 'login': true },
  children: {
    'sign_up': ['sign_up.email', "sign_up.facebook", 'sign_up.twitter'],
    'login': ['login.email', 'login.facebook', 'login.twitter'],
    'my': ['my.nodes', 'my.followings', 'my.liked']
  },
  parent: {
    "sign_up.facebook": "sign_up",
    "sign_up.email": "sign_up",
    "sign_up.twitter": "sign_up",
    "login.facebook": "login",
    "login.email": "login",
    "login.twitter": "login",
    'my.nodes': 'my',
    'my.liked': 'my',
    'my.followings': 'my',
  },
  errors: '',
  notifications: {}, notification_red: false,
  rootId: '',
  liked: {}, mine: {},
  userRanks: []
}

export const server = (state = initialServer, action) => {
  let d = {}, c={}, ch={}, pa={}, m={}, l={}
  switch (action.type) {
    case 'FETCH_CHILDREN_SUCCESS':
      for (let i = 0; i < action.contents.length; i++) {
        let parent = action.contents[i]
        for (let j = 0; j < parent.children.length; j++) {
          let child = parent.children[j]
          c[child.id] = content(child)
          if(ch[parent.id] === undefined){
            ch[parent.id] = []
          }
          ch[parent.id].push(child.id)
          pa[child.id] = parent.id
        }
        for (let j = 0; j < parent.stamps.length; j++) {
          let stamp = parent.stamps[j]
          let stamp_id = (parent.id + stamp.message)
          c[stamp_id] = { html: stamp_html(stamp.message, stamp.count),
            stamp: true, text: stamp.message }
          if(ch[parent.id] === undefined){
            ch[parent.id] = []
          }
          ch[parent.id].push(stamp_id)
          pa[stamp_id] = parent.id
        }
      }
      return {
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
      }
    case 'FETCH_CHILDREN_MINE_LIKED_SUCCESS':
      for (let i = 0; i < action.contents.length; i++) {
        let parent = action.contents[i]
        for (let j = 0; j < parent.children.length; j++) {
          let child = parent.children[j]
          if(child.mine) {
            m[child.id] = true
          }
          if(child.liked) {
            l[child.id] = true
          }
        }
      }
      return {
        ...state,
        mine: Object.assign(state.mine, m),
        liked: Object.assign(state.liked, l)
      }
    case 'FETCH_INITIAL_SUCCESS':
      let nodes = action.response.InitialNodes
      d[nodes.id] = true
      ch[nodes.id] = []
      c[nodes.id] = { text: nodes.text, html: nodes.html }
      for (let i = 0; i < nodes.children.length; i++) {
        c[nodes.children[i].id] = content(nodes.children[i])
        ch[nodes.id].push(nodes.children[i].id)
        pa[nodes.children[i].id] = nodes.id
      }
      for (let i = 0; i < nodes.stamps.length; i++) {
        let stamp = nodes.stamps[i]
        let id = (nodes.id + stamp.message)
        c[id] = { html: stamp_html(stamp.message, stamp.count),
            stamp: true, text: stamp.message }
        if(ch[nodes.id] === undefined){
          ch[nodes.id] = []
        }
        ch[nodes.id].push(id)
        pa[id] = nodes.id
      }
      return {
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
        fetch: Object.assign(state.fetch, d),
        rootId: action.response.InitialNodes.id,
        userRanks: action.response.UserRanks,
      }
    case 'FETCH_INITIAL_MINE_LIKED_SUCCESS':
      nodes = action.response
      if(nodes.mine) {
        m[nodes.id] = true
      }
      if(nodes.liked) {
        l[nodes.id] = true
      }
      for (let i = 0; i < nodes.children.length; i++) {
        if(nodes.children[i].mine) {
          m[nodes.children[i].id] = true
        }
        if(nodes.children[i].liked) {
          l[nodes.children[i].id] = true
        }
      }
      return {
        ...state,
        mine: Object.assign(state.mine, m),
        liked: Object.assign(state.liked, l)
      }
    case 'FETCH_NOTIFICATIONS_SUCCESS':
      let red = false;
      if(action.response.length !== 0 &&
          action.response[0].status === 'notified') {
        red = true;
      }
      return {
        ...state,
        notifications: action.response,
        notification_red: red
      }
    case 'FETCH_NODES_SUCCESS':
      c[action.response.id] = {
        id: action.response.id,
        text: action.response.text,
        html: action.response.html,
        owner_name: action.response.owner_name
      }
      d[action.response.id] = true
      let rootId = ''
      for (let i = 0, nodeId = action.response.id; i < action.response.ancients.length; i++) {
        let parent = action.response.ancients[i]
        pa[nodeId] = rootId = parent.id
        c[parent.id] = { text: parent.text, html: parent.html, owner_name: parent.owner_name }
        ch[parent.id] = [nodeId]

        nodeId = parent.id
      }
      if(typeof ch[action.response.id] === 'undefined') {
        ch[action.response.id] = []
      }
      for (let i = 0; i < action.response.children.length; i++) {
        let child = action.response.children[i]
        c[child.id] = { text: child.text, html: child.html, owner_name: child.owner_name }
        ch[action.response.id].push(child.id)
        pa[child.id] = action.response.id
      }
      for (let j = 0; j < action.response.stamps.length; j++) {
        let stamp = action.response.stamps[j]
        let stamp_id = (action.response.id + stamp.message)
        c[stamp_id] = { html: stamp_html(stamp.message, stamp.count),
            stamp: true, text: stamp.message }
        if(ch[action.response.id] === undefined){
          ch[action.response.id] = []
        }
        ch[action.response.id].push(stamp_id)
        pa[stamp_id] = action.response.id
      }
      if(rootId === ''){
        rootId = action.response.id
      }
      return {
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
        fetch: Object.assign(state.fetch, d),
        rootId: rootId,
      }
    case 'FETCH_NODES_MINE_LIKED_SUCCESS':
      if(action.response.mine) {
        m[action.response.id] = true
      }
      if(action.response.liked) {
        l[action.response.id] = true
      }
      for (let i = 0; i < action.response.ancients.length; i++) {
        let parent = action.response.ancients[i]
        if(parent.mine) {
          m[parent.id] = true
        }
        if(parent.liked) {
          l[parent.id] = true
        }
      }
      for (let i = 0; i < action.response.children.length; i++) {
        let child = action.response.children[i]
        if(child.mine) {
          m[child.id] = true
        }
        if(child.liked) {
          l[child.id] = true
        }
      }
      return {
        ...state,
        mine: Object.assign(state.mine, m),
        liked: Object.assign(state.liked, l)
      }
    case 'FETCH_NEXT_PAGE_SUCCESS':
      if(action.response.children.length === 0){
        return{
          ...state
        }
      }
      ch[action.response.id] = state.children[action.response.id]
      for (let i = 0; i < action.response.children.length; i++) {
        let child = action.response.children[i]
        if(ch[action.response.id].indexOf(child.id) >= 0) {
          continue
        }
        c[child.id] = content(child)
        ch[action.response.id].push(child.id)
        pa[child.id] = action.response.id
      }
      return {
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
      }
    case 'FETCH_NEXT_PAGE_MINE_LIKED_SUCCESS':
      if(action.response.children.length === 0){
        return{
          ...state
        }
      }
      for (let i = 0; i < action.response.children.length; i++) {
        let child = action.response.children[i]
        if(child.mine) {
          m[child.id] = true
        }
        if(child.liked) {
          l[child.id] = true
        }
      }
      return {
        ...state,
        mine: Object.assign(state.mine, m),
        liked: Object.assign(state.liked, l)
      }
    case 'FETCH_USER_NODES_SUCCESS':
      ch['my.nodes'] = []
      for (let i = 0; i < action.response.UserNodes.length; i++) {
        let node = action.response.UserNodes[i]
        c[node.id] = { text: node.text, html: node.html }
        ch['my.nodes'].push(node.id)
        pa[node.id] = 'my.nodes'
        if(node.mine) {
          m[node.id] = true
        }
        if(node.liked) {
          l[node.id] = true
        }
      }
      ch['my.liked'] = []
      for (let i = 0; i < action.response.LikedNodes.length; i++) {
        let node = action.response.LikedNodes[i]
        c[node.id] = { text: node.text, html: node.html, owner_name: node.owner_name }
        ch['my.liked'].push(node.id)
        pa[node.id] = 'my.liked'
        if(node.mine) {
          m[node.id] = true
        }
        if(node.liked) {
          l[node.id] = true
        }
      }
      return{
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
        mine: Object.assign(state.mine, m),
        liked: Object.assign(state.liked, l)
      }
    case 'FETCH_NEXT_USER_PAGE_SUCCESS':
      if(action.response.length === 0){
        return{
          ...state
        }
      }
      ch['my.nodes'] = state.children['my.nodes']
      for (let i = 0; i < action.response.length; i++) {
        let node = action.response[i]
        if(ch['my.nodes'].indexOf(node.id) >= 0) {
          continue
        }
        c[node.id] = { text: node.text, html: node.html }
        ch['my.nodes'].push(node.id)
        pa[node.id] = 'my.nodes'
        m[node.id] = true
        if(node.liked) {
          l[node.id] = true
        }
      }
      return{
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
        mine: Object.assign(state.mine, m),
        liked: Object.assign(state.liked, l)
      }
    case 'FETCH_NEXT_LIKED_PAGE_SUCCESS':
      if(action.response.length === 0){
        return{
          ...state
        }
      }
      ch['my.liked'] = state.children['my.liked']
      for (let i = 0; i < action.response.length; i++) {
        let node = action.response[i]
        if(ch['my.liked'].indexOf(node.id) >= 0) {
          continue
        }
        c[node.id] = { text: node.text, html: node.html, owner_name: node.owner_name }
        ch['my.liked'].push(node.id)
        pa[node.id] = 'my.liked'
        l[node.id] = true
        if(node.mine) {
          m[node.id] = true
        }
      }
      return{
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
        mine: Object.assign(state.mine, m),
        liked: Object.assign(state.liked, l)
      }
    case 'CREATE_NODE_SUCCESS':
      c[action.response.id] = action.response
      ch[action.parent_id] = [action.response.id].concat(state.children[action.parent_id])
      pa[action.response.id] = action.parent_id
      m[action.response.id] = true
      return {
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
        mine: Object.assign(state.mine, m),
      }
    case 'EDIT_NODE_SUCCESS':
      c[action.response.id] = action.response
      if(action.response.liked) {
        l[action.response.id] = true
      }
       return {
        ...state,
        contents: Object.assign(state.contents, c),
        liked: Object.assign(state.liked, l)
      }
    case 'CREATE_USER_SUCCESS':
    case 'LOGIN_USER_SUCCESS':
    case 'FORGOT_PASSWORD_SUCCESS':
    case 'RESET_PASSWORD_SUCCESS':
      return{
        ...state,
        errors: {}
      }
    case 'GET_USER_ERRORS':
    case 'GET_CONFIRM_ERRORS':
    case 'FORGOT_PASSWORD_ERRORS':
    case 'RESET_PASSWORD_ERRORS':
      return{
        ...state,
        errors: action.response,
      }
    case 'DELETE_NODE_SUCCESS':
      let parent = state.parent[action.id]
      ch[parent] = state.children[parent]
      for(let i=0; i<ch[parent].length; i++){
        if(ch[parent][i] === action.id){
          ch[parent].splice(i--, 1);
        }
      }
      c = state.contents
      delete c[action.id]
      pa = state.parent
      delete pa[action.id]
      return {
        ...state,
        contents: c,
        parent: pa,
        children: Object.assign(state.children, ch)
      }
    case 'UPDATE_NOTIFICATIONS_SUCCESS':
      return {
        ...state,
        notification_red: false
      }
    case 'FETCH_NODER_NODES_SUCCESS':
      if(action.locale === 'en') {
        c[action.name] = { text: '@' + action.name + "'s nodes" }
      } else{
        c[action.name] = { text: '@' + action.name + "<br>が作ったノード" }
      }
      ch[action.name] = []
      for (let i = 0; i < action.response.length; i++) {
        c[action.response[i].id] = action.response[i]
        ch[action.name].push(action.response[i].id)
        pa[action.response[i].id] = action.name
      }
      return {
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa)
      }
    case 'STAMP_NODE_SUCCESS':
      let stamp_id = action.id+action.message
      c[stamp_id] = { html: stamp_html(action.message, action.response.count),
            stamp: true, text: action.message }
      if(state.children[action.id] === undefined){
        ch[action.id] = []
      } else {
        ch[action.id] = state.children[action.id]
      }
      if(ch[action.id].indexOf(stamp_id) === -1){
        ch[action.id].push(stamp_id)
      }
      pa[stamp_id] = action.id
      return {
        ...state,
        contents: Object.assign(state.contents, c),
        children: Object.assign(state.children, ch),
        parent: Object.assign(state.parent, pa),
      }
    default:
      return state;
  }
};

const content = node => ({
  text: node.text, html: node.html, owner_name: node.owner_name
})

const stamp_html = (message, count) => {
  switch (message) {
    case 'useful':
      if(cookies.get('locale') === 'en') {
        return(`Useful<br><i class=\"fas fa-child fa-3x\" \/><br>${count}`)
      } else {
        return(`役に立つ<br><i class=\"fas fa-child fa-3x\" \/><br>${count}`)
      }
    case 'funny':
      if(cookies.get('locale') === 'en') {
        return(`Funny<br><i class=\"fab fa-reddit-alien fa-3x\" \/><br>${count}`)
      } else {
        return(`面白い<br><i class=\"fab fa-reddit-alien fa-3x\" \/><br>${count}`)
      }
    case 'cool':
      if(cookies.get('locale') === 'en') {
        return(`???<br><i class=\"fab fa-napster fa-3x\" \/><br>${count}`)
      } else {
        return(`なにこれ？<br><i class=\"fab fa-napster fa-3x\" \/><br>${count}`)
      }
    case 'money':
      if(cookies.get('locale') === 'en') {
        return(`Money<br><i class=\"far fa-money-bill-alt fa-3x\" \/><br>${count}`)
      } else {
        return(`お金が儲かる<br><i class=\"far fa-money-bill-alt fa-3x\" \/><br>${count}`)
      }
    default:
      return(null)
  }
}

export default server;



// WEBPACK FOOTER //
// ./src/reducers/server.js